import { getSogniClientInstance } from '../sogni-client.svelte.js';
import { loadImageModelCatalog, getCatalogModel } from '../state/model-catalog.svelte.js';
import { imageReferences } from '../state/image-references.svelte.js';
import { studioSettings } from '../state/settings.svelte.js';
import { resolveImageModelParameters } from './image-model-parameters.js';

export async function buildModelProjectParams(modelId, options = {}) {
  const {
    width, height, network = studioSettings.network, preset = studioSettings.renderPreset,
    modelOverrides = studioSettings.modelOverrides[modelId] || {},
    disableNSFWFilter = false, referenceAssets = imageReferences.assets,
    guideImage = imageReferences.guideImage, guideStrength = imageReferences.guideStrength
  } = options;
  // An immutable request can resolve its captured assets while the uploader is
  // already editing the next request. Live inputs must finish reading first.
  if (imageReferences.isLoading && (!Object.hasOwn(options, 'referenceAssets') || !Object.hasOwn(options, 'guideImage'))) {
    throw new Error('Wait for the original image to finish loading.');
  }
  const references = referenceAssets.map((asset) => ({ ...asset }));
  const guide = guideImage ? { ...guideImage } : null;
  const overrides = { ...modelOverrides };
  await loadImageModelCatalog();
  const model = getCatalogModel(modelId);
  if (!model) {
    const error = new Error(`Model ${modelId} is not an active image generator. Choose another model.`);
    error.code = 'SELECTED_MODEL_UNAVAILABLE';
    throw error;
  }
  const client = getSogniClientInstance();
  if (!client) throw new Error('Sogni client is not connected. Sign in again.');
  const [modelOptions, sizePresets] = await Promise.all([
    client.projects.getModelOptions(modelId),
    client.projects.getSizePresets(network, modelId)
  ]);
  return resolveImageModelParameters(model, {
    width, height, network, preset, modelOverrides: overrides, disableNSFWFilter,
    referenceAssets: references, guideImage: guide, guideStrength, modelOptions, sizePresets
  });
}
